import type { ComponentProps, MouseEventHandler } from 'react'
import { useCallback } from 'react'
import Caption from '../Typography/Caption'
import TextLink from '../TextLink'
import { useIntl } from 'react-intl'

interface Props {
  size: 'M' | 'L'
  onClick: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
}

const SIZES_CAPTION_WEIGHTS: Record<Props['size'], ComponentProps<typeof Caption>['weight']> = {
  M: 'normal',
  L: 'bold',
}

function PriceRowPriceDetails(props: Props) {
  const {
    size,
    onClick,
  } = props
  const intl = useIntl()

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onClick(event)
  }, [onClick])

  return <Caption
    variant="medium"
    weight={SIZES_CAPTION_WEIGHTS[size]}
  >
    <TextLink onClick={handleClick}>
      {intl.formatMessage({
        id: 'uwx1WBaUwRdrzY_m1ziY',
        defaultMessage: 'Price details',
        description: 'Link label indicating that the price details are available',
      })}
    </TextLink>
  </Caption>
}

export default PriceRowPriceDetails
